import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import { Project, ProjectDetailsField } from 'nekst-api';
import { ShowMoreTextField } from '../../../shared/widgets/ShowMoreTextWrapper';
import { UpdateFieldWrapper } from "./UpdateFieldWrapper";

export default function TextDetailsField(
  props: {
    field: ProjectDetailsField,
  },
) {
  const context = useShowContextRequired<Project>();

  const details = context.data.statistic!.details;

  const field = details
    .find((d) => d.setting.id === props.field.id);

  const result = field?.value as string || '';

  let content;
  if (result) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    content =  (
      <ShowMoreTextField
        source={props.field.id.toString()}
        value={result}
        maxLength={40}
      />
    );
  } else {
    content = <>-</>;
  }

  return (
    <UpdateFieldWrapper field={props.field}>
      {content}
    </UpdateFieldWrapper>
  )
}
